import { baseUrl } from "@/config/env";
import request from "@/router/axios";
// 下载 HVAC 套餐二维码
export const getDownloadCode = (params) => {
  return request({
    url: `${baseUrl}/joins-product/v1/app_product/getMiniProgramCodeImage`,
    method: "POST",
    data: params,
  });
};
// 获取 HVAC 套餐列表
export const getHvacPackageList = (params) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/combo`,
    method: "get",
    params,
  });
};

// 获取 HVAC 套餐详情
export const getHvacPackageDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/combo/info/${id}`,
    method: "get",
  });
};

// 新增 HVAC 套餐
export const addHvacPackage = (data) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/combo`,
    method: "post",
    data,
  });
};

// 编辑 HVAC 套餐
export const editHvacPackage = (data) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/combo`,
    method: "put",
    data,
  });
};

// 删除 HVAC 套餐
export const deleteHvacPackage = (id) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/combo/${id}`,
    method: "delete",
  });
};

// 启用 HVAC 套餐
export const enableHvacPackage = (params) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/combo/startOrStop`,
    method: "get",
    params,
  });
};

// 停用 HVAC 套餐
export const disableHvacPackage = (params) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/combo/startOrStop`,
    method: "get",
    params,
  });
};

// 生成 HVAC 套餐二维码
export const generateHvacPackageQrCode = (params) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/qr`,
    method: "post",
    data: params,
  });
};

// 获取二维码列表
export const getQrCodeList = (params) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/qr`,
    method: "get",
    params,
  });
};
// 获取二维码详情
export const getQrCodeDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/qr/info/${id}`,
    method: "get",
  });
};
// 修改二维码
export const updateQrCode = (params) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/qr`,
    method: "put",
    data: params,
  });
};
// 删除二维码
export const deleteQrCode = (id) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/qr/${id}`,
    method: "delete",
  });
};
// 启停二维码
export const startOrStopQrCode = (params) => {
  return request({
    url: `${baseUrl}/joins-resource/v1/qr/startOrStop`,
    method: "get",
    params,
  });
};
